/*=============================================== Tag ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
import Mixins from "./Mixins";
/*==================== Component ====================*/
var Tag = function (_a) {
    var _b = _a.tagStyle, tagStyle = _b === void 0 ? "rounded" : _b, _c = _a.color, color = _c === void 0 ? "primary" : _c, children = _a.children, props = __rest(_a, ["tagStyle", "color", "children"]);
    return (React.createElement(Container, __assign({ "$tagStyle": tagStyle, "$color": color }, props), children));
};
export default Tag;
/*==================== Types ====================*/
var tagStyles = {
    pill: "pill",
    rounded: "rounded",
};
/*==================== Styles ====================*/
var Container = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    padding: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n"], ["\n    font-size: ", ";\n    padding: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n"])), Variables.FontSizes.Small, function (_a) {
    var $tagStyle = _a.$tagStyle;
    return $tagStyle === "pill"
        ? "".concat(Variables.Spacers.XXS, " ").concat(Variables.Spacers.M)
        : "".concat(Variables.Spacers.XXS, " ").concat(Variables.Spacers.S);
}, function (_a) {
    var $tagStyle = _a.$tagStyle;
    return ($tagStyle === "pill" ? Variables.Radiuses.Round : Variables.Radiuses.S);
}, Mixins.ColorsShort, function (_a) {
    var $color = _a.$color;
    return ($color === "white" ? Variables.Colors.Primary500 : Variables.Colors.White);
});
var templateObject_1;
